import { useEffect } from 'react'
import { requestTrackingPermissionsAsync } from '@/src/services/ExpoTrackingTransparency/requestTrackingPermissionsAsync'
import { useLogError } from './useLogError'
import { useIsUserSignedIn } from './useIsUserSignedIn'

export function useRequestAppPermissions() {
  const logError = useLogError()
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  const { isSignedIn } = useIsUserSignedIn()

  useEffect(() => {
    void (async () => {
      if (!isSignedIn) {
        return
      }

      try {
        // Tracking permission is required for AppsFlyer to work
        await requestTrackingPermissionsAsync()

        // Tracking permission is required for Braze
      } catch (error) {
        logError('Error requesting tracking permissions:', error)
      }
    })()
  }, [logError, isSignedIn])
}
